<template>
  <div v-if="$store.state.app.basics.modules &&
      $store.state.app.basics.modules.indexOf('reputation') > -1" class="flex wrap indicate">
    <div class="fill p16 indicate" v-if="$store.state.auth.uid">
      <div class="flex between align-center">
        <b>Give Feedback</b>
      </div>

      <div class="flex align-center" style="width: 100%">
        <textarea
          autofocus="true"
          class="fill p4"
          type="text"
          v-model="feedback.content"
          placeholder="Review"
        ></textarea>
        <div class="flex column center">
          <div class="flex around align-center p4">
            <span :key="xKey" v-for="(x, xKey) in 5">
              <i
                :class="`fa${feedback.quality > xKey ? 's' : 'r'} fa-star`"
                @click="feedback.quality = x"
              ></i>
            </span>
          </div>
          <button
            class="indicate m8 p8"
            type="button"
            @click.prevent="
              $store.dispatch('create', {
                type: 'reputation',
                id: repid || $route.params.id || $route.params.iitemid,
                data: feedback,
                fType,
              });
              feedback = { content: '', quality: 5 };
            "
          >
            Publish
          </button>
        </div>

      </div>
    </div>

    <div
      v-if="
        $store.state.counter &&
        $store.state.reputation[repid] &&
        $store.state.reputation[repid].data
      "
      :key="'reviews' + repid + $store.state.counter"
      class="flexy"
    >
      <div
        :style="`max-height: 66%; ${
          $store.state.windowWidth >= 480 ? 'overflow-x: scroll;' : ''
        }`"
        class="flex flexy fill"
        :class="rep.feedback.content ? 'container b4' : ''"
        :key="rep.rId"
        v-for="rep in orderByDate($store.state.reputation[this.repid].data)"
      >
        <div
          v-if="rep.feedback.content"
          class="sub-container flex column between flexy"
        >
          <div class="between flex wrap align-center xs-font p4">
            <user :userid="rep.user"></user>
            <itime class="r8 update-text" :timestamp="rep.timestamp"></itime>
            <span class="flex around align-center">
              <i
                :key="xKey"
                v-for="(x, xKey) in rep.feedback.quality"
                class="fas fa-star indicate-text"
              ></i>
            </span>
          </div>
          <div class="flex wrap column fill">
            <span v-if="rep.feedback.content" class="p4">
              <icontent
                :content="rep.feedback.content"
              />
            </span>
          </div>
          <reputation
            class="xs-font"
            :key="$store.state.componentKeys.reputation + rep.rId"
            :fId="rep.rId"
            fType="reputation"
            type="reputation"
          ></reputation>
        </div>
      </div>
    </div>
    <div
      class="flex center column indicate fill"
      v-if="
        $store.state.reputation[repid] && !$store.state.reputation[repid].data
      "
    >
      <reputation
        :key="$store.state.componentKeys.reputation + repid"
        :class="`${$store.state.device.mobile ? 'p4' : 'p16'}`"
        :fId="repid || $route.params.id || $route.params.iitemid "
        fType="profile"
        type="profile"
      ></reputation>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

export default {
  name: "reviews",
  data() {
    return {
      feedback: { content: "", quality: 5 },
      fType: this.$route.name,
      showFullFeedback: {},
    };
  },
  methods:{
    orderByDate(set) {
      let newset = _.orderBy(set, "timestamp", "desc");
      return newset
    },
  },
  props: {
    repid: { type: String },
    type: { type: String },
  }
};
</script>